import { ReactNode } from "react";
import { X } from "lucide-react";
import cn from "@/lib/cn";
import { Backdrop } from "./Backdrop";
import { Button } from "./Button";

interface DrawerHeader {
  start?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
}

interface DrawerProps {
  open: boolean;
  onClose: VoidFunction;
  children: ReactNode;
  header?: DrawerHeader;
  className?: string;
}

export function Drawer({
  open,
  onClose,
  children,
  header,
  className,
}: DrawerProps) {
  if (!open) return null;

  const hasHeader = header && (header.start || header.title || header.subtitle);

  return (
    <div className="animate-v5-overlay-fade-in fixed inset-0 z-40 flex items-stretch justify-end">
      <Backdrop onClick={onClose} />

      <div className="relative z-1 box-border flex h-full p-3">
        <div
          className={cn(
            "animate-v5-tray-slide-in flex h-full w-[560px] flex-col overflow-hidden rounded-xl bg-(--surface-content) shadow-[0_24px_80px_rgba(0,0,0,0.15),0_0_0_1px_rgba(0,0,0,0.03)]",
            className,
          )}
        >
          {hasHeader && (
            <div className="shrink-0 border-b border-[#EBEDF2] bg-white px-7 pt-6 pb-5">
              <div className="flex items-center gap-3.5">
                {header.start}
                <div className="min-w-0 flex-1">
                  {header.title}
                  {header.subtitle}
                </div>
                <Button
                  onClick={onClose}
                  icon={X}
                  aria-label="Close"
                  size="lg"
                  className="rounded-[12px]"
                />
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
